const requireModule = require.context('.', true, /\.vue$/)
import { getCustomSteps, SortByLocation } from '@/utils'
import customStepComponent from './CustomFields.vue'

import { path } from 'ramda'

const data = requireModule
  .keys()
  .sort()
  .filter(fileName => {
    if (fileName.endsWith('index.js')) return false
    return true
  })

export default function (item) {
  let base = data.reduce((res, fileName) => {
    const module = requireModule(fileName)
    if (module.meta.skip) return res

    res.push({
      component: module.default,
      ...module.meta,
    })

    return res
  }, [])

  let dynamicPlacements = (item.customFieldsConfig || [])
    .flatMap(({ schema }) => schema.map(i => path(['placement'], i)))
    .filter(i => {
      const step = path(['step'], i)

      if (!step) return false
      return !base.find(({ id }) => step === id || step.startsWith(`${id}-`))
    })

  let steps = [...base, ...getCustomSteps(dynamicPlacements, 'residential-template', { item, customStepComponent })]

  const sortedByOrder = steps.sort((a, b) => {
    return a.order - b.order
  })

  return SortByLocation(sortedByOrder)
}
